<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif, '微软雅黑';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
  height: 100%;
}
html,body{
  height: 100%;
}
.flex-column {
  display: flex;
  flex-direction: column;
  height: 100%;
  /* padding-top: 3rem; */
}
.mt-4rem {
  margin-top: 4rem;
}
.bg-blue-linear {
  /* background: linear-gradient(90deg, #09a7fb, #007bff); */
  background-image: radial-gradient(circle, #104883, #022952);
}
.text-white {
  color: white;
}
.van-nav-bar__title {
  color: white;
}
.van-nav-bar__text {
  color: white;
}
.van-nav-bar .van-icon {
  color: white;
}
.van-card__title {
  font-size: 1.1rem;
  /* font-weight: bold; */
  line-height: 1.5rem;
  max-height: 3rem;
}
.van-card__thumb img {
    border-radius: 5px;
}
.van-card__footer {
  margin-top: -0.8rem;
}
.van-card__thumb {
  width: 120px;
}
#skeleton-header .van-skeleton__title {
  height: 3.5rem;
  position: fixed;
  top: 0;
  left: 0;
}
#skeleton-banner .van-skeleton__title {
  height: 12rem;
  margin-top: 10px;
}
#skeleton-footer .van-skeleton__title {
  height: 8rem;
  margin-top: 10px;
}
#skeleton-title .van-skeleton__title {
  height: 50px;
}
#skeleton-cell .van-skeleton__row {
  height: 30px;
}
#skeleton-ad .van-skeleton__title {
  height: 4rem;
}
#skeleton-ad .van-skeleton__row {
  height: 4rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue